/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m7.5802 12.3655.002.0005a2.2465 2.2465 0 0 1 1.4644 1.3226l2.8775 7.1622.001.0025a.635.635 0 0 0 .7281.3808c1.0118-.2289 1.6858-1.1893 1.5591-2.2214l-.6951-5.6622h8.2376c.483 0 .8394-.4521.7278-.9232l-1.9828-8.375-.0004-.0017a.7484.7484 0 0 0-.7274-.5751H8.8186a2.2397 2.2397 0 0 0-1.0424.2574l-.0029.0015-1.7887.9439v7.2308l1.5956.4564Zm14.1746 2.485c.0292 0 .0583-.0006.0872-.0017 1.4037-.053 2.4234-1.3819 2.0967-2.7663l-.0004-.0017-1.9828-8.375c-.2401-1.0143-1.1437-1.7303-2.1835-1.7303H8.8186a3.7327 3.7327 0 0 0-1.742.4316l-1.1622.6131a1.502 1.502 0 0 0-.2474-.4688c-.2738-.3506-.7-.576-1.1786-.576H0v12.7501h4.4884c.6198 0 1.1516-.3779 1.3787-.9164.046-.109.0795-.2246.0987-.345 0 .0001 0-.0001 0 0l1.2042.3439a.7467.7467 0 0 1 .2332.1134.7498.7498 0 0 1 .2546.3252l.001.0024 2.8775 7.1622c.3906.9721 1.4267 1.5168 2.4463 1.2861a.0075.0075 0 0 0 .0016-.0004c1.7604-.3992 2.9332-2.0704 2.7132-3.8665-.0001-.0003 0 .0003 0 0l-.4886-3.9799h6.546Zm-17.2664-1.625H1.4961v-9.75h2.9923v9.75Z"
    clipRule="evenodd"
  />,
  'Dislike'
);
